var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gisLocationManAlt0",
    d: "M12.9329 8C10.3289 8.00032 7.74842 9.08575 8.01967 11.2547L8.68448 15.9691C8.80148 16.7988 9.3792 18.1251 10.2428 18.1251H10.3043L11.0113 26.3553C11.0419 26.7108 11.3078 27 11.6761 27H14.3354C14.7037 27 14.9696 26.7108 15.0002 26.3553L15.7072 18.1251H15.7687C16.632 18.1251 17.21 16.7985 17.327 15.9691L17.9918 11.2547C18.1657 9.08382 15.5373 7.99936 12.9329 8Z",
    fill: "#0E0B1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gisLocationManAlt2",
    d: "M7.80195 22C3.211 22.7096 0 24.407 0 26.9058C0 30.2716 5.3651 33 13 33C20.6349 33 26 30.2716 26 26.9058C26 24.407 22.7893 22.7096 18.1987 22L17.5627 23.1845C21.0226 23.7096 23.4 24.813 23.4 26.0935C23.4 27.8887 18.7437 29.3438 13 29.3438C7.25627 29.3438 2.6 27.8887 2.6 26.0935C2.59967 24.8173 4.96145 23.7149 8.43212 23.1877C8.2225 22.7917 8.0119 22.3964 7.80195 22Z",
    fill: "#0E0B1D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gisLocationManAlt3",
    d: "M13 7C14.6569 7 16 5.433 16 3.5C16 1.567 14.6569 0 13 0C11.3431 0 10 1.567 10 3.5C10 5.433 11.3431 7 13 7Z",
    fill: "#0E0B1D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2Icon);
export default __webpack_public_path__ + "static/media/circle-2-icon.2d9cfc978dc3f007ad9bbd436fa96711.svg";
export { ForwardRef as ReactComponent };